import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const ConnectionRestoredNotification = ({ isVisible, onDismiss }) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (isVisible) {
            const timeout = setTimeout(() => {
                onDismiss();
            }, 5000);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [isVisible]);
    return isVisible ? (_jsx("div", Object.assign({ className: "container-with-sidenav container--fixed-height container-success-status notification-fade" }, { children: t('NOTIFICATIONS.CONNECTION_RESTORED') }), void 0)) : null;
};
export default ConnectionRestoredNotification;
